// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString));
var aptNumberIsSymbol = {
    reflectSymbol: function () {
        return "aptNumber";
    }
};
var cityIsSymbol = {
    reflectSymbol: function () {
        return "city";
    }
};
var floorIsSymbol = {
    reflectSymbol: function () {
        return "floor";
    }
};
var postCodeIsSymbol = {
    reflectSymbol: function () {
        return "postCode";
    }
};
var streetIsSymbol = {
    reflectSymbol: function () {
        return "street";
    }
};
var streetNumberIsSymbol = {
    reflectSymbol: function () {
        return "streetNumber";
    }
};
var showMaybe = /* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString);
var PaymentAddressIsSymbol = {
    reflectSymbol: function () {
        return "PaymentAddress";
    }
};
var decodeMaybe = /* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1);
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var encodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode));
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode);
var decodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode));
var PaymentAddress = function (x) {
    return x;
};
var toFillFormTypePaymentAddr = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypePaymentAddress_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldPaymentAddress = function (dictHasField) {
    return dictHasField;
};
var eqPaymentAddress = {
    eq: function (x) {
        return function (y) {
            return eq(x.aptNumber)(y.aptNumber) && x.city === y.city && eq(x.floor)(y.floor) && x.postCode === y.postCode && x.street === y.street && x.streetNumber === y.streetNumber;
        };
    }
};
var genericPaymentAddress = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showPaymentAddress = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPaymentAddress)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(aptNumberIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(cityIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(floorIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(postCodeIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(streetIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(streetNumberIsSymbol)(Data_Show.showString))(Data_Show.showString))(Data_Show.showString))(showMaybe))(Data_Show.showString))(showMaybe))))(PaymentAddressIsSymbol))
};
var unscrambleDecodePaymentAddress = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPaymentAddress)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(aptNumberIsSymbol)(decodeMaybe)(/* #__PURE__ */ Unscramble.decodeRecordCons(cityIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(floorIsSymbol)(decodeMaybe)(/* #__PURE__ */ Unscramble.decodeRecordCons(postCodeIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(streetIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(streetNumberIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))))))))(Unscramble_Generic.defaultOptions)
};
var encodePaymentAddress = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPaymentAddress)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PaymentAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(streetNumberIsSymbol)(encodeWithOptionsOther))(streetIsSymbol)(encodeWithOptionsOther))(postCodeIsSymbol)(encodeWithOptionsOther))(floorIsSymbol)(encodeWithOptionsOther1))(cityIsSymbol)(encodeWithOptionsOther))(aptNumberIsSymbol)(encodeWithOptionsOther1)))))
};
var decodePaymentAddress = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPaymentAddress)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PaymentAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(streetNumberIsSymbol)(decodeWithOptionsOther)())(streetIsSymbol)(decodeWithOptionsOther)())(postCodeIsSymbol)(decodeWithOptionsOther)())(floorIsSymbol)(decodeWithOptionsOther1)())(cityIsSymbol)(decodeWithOptionsOther)())(aptNumberIsSymbol)(decodeWithOptionsOther1)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    PaymentAddress,
    genericPaymentAddress,
    eqPaymentAddress,
    showPaymentAddress,
    encodePaymentAddress,
    decodePaymentAddress,
    unscrambleDecodePaymentAddress,
    toFillFormTypePaymentAddr,
    hasFieldPaymentAddress,
    newtypePaymentAddress_
};
